import ImageGallery from "components/image-gallery";
import { useState } from "react";
import { FeedItem } from "ztypes/feed";
import iconDown from "images/ic_down.svg";
import IconUp from "icons/icon-up";
import IconThreeDot from "icons/icon-three-dot";

interface FeedProps {
  ecode: FeedItem;
}
const CAPTION_MAX_LENGTH = 200;

const Feed: React.FC<FeedProps> = (props) => {
  const feedItem = props.ecode;
  const [isHidden, setIsHidden] = useState<boolean>(true);
  const date = new Date(feedItem.cts);
  const dateTimeStr = `Được đăng vào ngày ${date.getDate()} tháng ${
    date.getMonth() + 1
  }, ${date.getFullYear()}`;
  const caption = feedItem.content.caption;
  return (
    <div className="px-4 flex flex-col rounded-[4px] bg-white">
      {isHidden ? (
        <div
          className="py-4 flex items-center space-x-3"
          onClick={() => {
            setIsHidden(false);
          }}
        >
          <img
            className="rounded w-10 h-10 object-cover"
            src={feedItem.content.photos[0].thumb}
            alt=""
          />
          <div className="flex flex-col flex-grow items-start">
            <div className="font-medium text-[14px] leading-[18px] line-clamp-1">
              {caption}
            </div>
            <div
              className="font-normal text-[14px] leading-[18px]"
              style={{ color: "#6F7071" }}
            >
              {dateTimeStr}
            </div>
          </div>
          <img className="w-4 h-4 pointer-events-none" src={iconDown} alt="" />
        </div>
      ) : (
        <div className="flex flex-col items-center">
          <div
            className="w-full  my-4 p-4 flex flex-col items-start rounded-xl border-solid border-[1px] space-y-4"
            style={{ borderColor: "rgba(0, 0, 0, 0.15)" }}
          >
            <div className=" mr-[13px] flex self-stretch flex-grow justify-between items-center">
              <div className="flex flex-row space-x-4">
                <img
                  className="w-8 h-8 rounded-full"
                  src={feedItem.header.avt}
                  alt=""
                />
                <div className="flex flex-col">
                  <div
                    className="font-medium text-[12px] leading-[16px]"
                    style={{ color: "#0D0D0D" }}
                  >
                    {feedItem.header.dpn}
                  </div>
                  <div
                    className="font-normal text-[11px] leading-[16px]"
                    style={{ color: "#6F7071" }}
                  >
                    {feedItem.header.title}
                  </div>
                </div>
              </div>
              <IconThreeDot className="w-4 h-4" />
            </div>
            <div className="pr-[13px] font-normal text-[13px] leading-[17px] ">
              {caption && caption.length > CAPTION_MAX_LENGTH ? (
                <div>
                  {caption.slice(0, CAPTION_MAX_LENGTH)}...
                  <span className="text-neutral-500">Xem thêm</span>
                </div>
              ) : (
                <div>{caption}</div>
              )}
            </div>
            <ImageGallery photos={feedItem.content.photos} />
            <div className="px-[10.13px] w-full flex flex-row justify-between">
              <div className="py-2 font-medium text-[11.822px] leading-[15.2px]">
                Tìm hiểu về sản phẩm
              </div>
              <div
                className="py-2 px-3 font-medium text-[11.822px] leading-[15.2px] rounded-[84px]"
                style={{ backgroundColor: "#EBEDEF" }}
              >
                Gửi tin nhắn
              </div>
            </div>
          </div>
          <div
            className="m-auto pb-4 flex flex-row space-x-1"
            onClick={() => setIsHidden(true)}
          >
            <div className="flex font-medium text-[14px] leading-[18px]">
              Thu gọn
            </div>
            <IconUp className="w-4 h-4" />
          </div>
        </div>
      )}
    </div>
  );
};

export default Feed;
